import { IconButton, Tooltip, SvgIcon } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import copyIconImg from "@static/img/icons/copy.svg";

interface IParams {
    textToCopy: string;
}

export const CopyTextFieldIcon = (props: IParams) => {
    const { textToCopy } = props;
    const { t } = useTranslation("common");
    const [isTextCopied, setIsTextCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(textToCopy);
        setIsTextCopied(true);
        setTimeout(() => setIsTextCopied(false), 2000);
    };

    return (
        <Tooltip
            color="secondary"
            disableFocusListener
            disableTouchListener
            placement="top-end"
            title={isTextCopied ? `${t("copied")} !` : t("copy")}
        >
            <IconButton aria-label="Copy" onClick={handleCopy}>
                <SvgIcon component={copyIconImg} />
            </IconButton>
        </Tooltip>
    );
};
